const mediaQueries = {
  papaBear: function() {
    return window.matchMedia("(min-width: 60em)").matches;
  },
  grandpaBear: function() {
    return window.matchMedia("(min-width: 70em)").matches;
  },
  prefersReducedMotion: () => {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
}

const cssSupport = {
  clipPath: function() {
    return CSS.supports("clip-path", "url(test.svg)");
  }
}


export { mediaQueries, cssSupport };